module.exports = __webpack_public_path__ + "img/cooperation-way-bg2.2aa7e3c5.png";